(function() {
  var HIDE_SELECTORS = [
    '.yotpo-sr-bottom-line-left-panel',
    '.yotpo-sr-bottom-line-score',
    '.yotpo-sr-bottom-line-right-panel',
    '.yotpo-sr-bottom-line-text',
    '.yotpo-sr-vertical-border',
    '.text-m',
    '.yotpo-bottom-line-text'
  ].join(',');

  var formatting = false;
  var refreshTimers = [];

  function parseReviewCount(text) {
    if (!text) return '';
    var match = String(text).replace(/reviews?/gi, '').match(/(\d[\d,]*)/);
    return match ? match[1].replace(/,/g, '') : '';
  }

  function isLikelyRatingScore(value, scaleMax) {
    var score = parseFloat(value);
    var max = scaleMax || 5;
    if (isNaN(score)) return false;
    return score >= 0 && score <= max;
  }

  function formatScore(value) {
    var score = parseFloat(value);
    if (isNaN(score)) return '';
    return score % 1 === 0 ? String(score) : score.toFixed(1).replace(/\.0$/, '');
  }

  function parseScoreFromAria(text) {
    if (!text) return '';
    var source = String(text);
    var match = source.match(/(\d+(?:\.\d+)?)\s*(?:out of|\/)\s*(\d+(?:\.\d+)?)/i);
    if (match && isLikelyRatingScore(match[1], parseFloat(match[2]))) {
      return match[1];
    }
    match = source.match(/rated\s+(\d+(?:\.\d+)?)/i);
    if (match && isLikelyRatingScore(match[1])) {
      return match[1];
    }
    return '';
  }

  function readScoreFromDom(summary) {
    var score = '';

    summary.querySelectorAll('.yotpo-sr-bottom-line-left-panel, .yotpo-sr-bottom-line-score').forEach(function(node) {
      if (score) return;
      var candidate = formatScore(node.textContent.trim());
      if (isLikelyRatingScore(candidate)) {
        score = candidate;
      }
    });

    if (!score) {
      score = parseScoreFromAria(summary.getAttribute('aria-label') || '');
    }

    if (!score) {
      var stars = summary.querySelector('.yotpo-sr-stars, .yotpo-stars');
      if (stars) {
        score = parseScoreFromAria(stars.getAttribute('aria-label') || '');
      }
    }

    return score;
  }

  function readCountFromDom(summary) {
    var count = '';

    summary.querySelectorAll('.yotpo-sr-bottom-line-right-panel, .yotpo-sr-bottom-line-text').forEach(function(node) {
      if (node.classList.contains('voyager-yotpo-rating-text')) return;
      if (count) return;
      count = parseReviewCount(node.textContent);
    });

    return count;
  }

  function readDataScore(container) {
    var score = container.getAttribute('data-voyager-rating-score');
    if (score && isLikelyRatingScore(score)) {
      return formatScore(score);
    }
    return '';
  }

  function readDataCount(container) {
    var count = container.getAttribute('data-voyager-rating-count');
    if (!count) return '';
    return parseReviewCount(count);
  }

  function hideNativeYotpoText(root) {
    root.querySelectorAll(HIDE_SELECTORS).forEach(function(node) {
      if (node.classList.contains('voyager-yotpo-rating-text')) return;
      node.setAttribute('hidden', 'hidden');
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function getOrCreateRatingText(summary) {
    var nodes = summary.querySelectorAll('.voyager-yotpo-rating-text');
    var textEl = nodes[0];

    nodes.forEach(function(node, index) {
      if (index > 0) node.remove();
    });

    if (!textEl) {
      textEl = document.createElement('span');
      textEl.className = 'voyager-yotpo-rating-text';
      summary.appendChild(textEl);
    }

    return textEl;
  }

  function shouldHideEmptyRating(score, count) {
    var countNum = parseInt(count, 10);
    var scoreNum = parseFloat(score);

    if (count !== '' && !isNaN(countNum) && countNum <= 0) return true;
    if (score !== '' && !isNaN(scoreNum) && scoreNum <= 0) return true;
    return false;
  }

  function hideEmptyRating(container) {
    if (!container) return;
    container.classList.add('voyager-yotpo-rating--empty');
    container.setAttribute('hidden', 'hidden');
    container.setAttribute('aria-hidden', 'true');
  }

  function formatStarRatingSummary(container, summary) {
    if (!summary || summary.dataset.voyagerRatingFormatted === 'true') return;

    var score = readScoreFromDom(summary) || readDataScore(container);
    var count = readCountFromDom(summary) || readDataCount(container);

    if (shouldHideEmptyRating(score, count)) {
      hideEmptyRating(container);
      return;
    }

    if (!count || !score) return;
    if (!container.querySelector('svg, .yotpo-sr-stars, .yotpo-stars')) return;

    var textEl = getOrCreateRatingText(summary);
    textEl.textContent = score + ' (' + count + ')';

    hideNativeYotpoText(summary);
    summary.dataset.voyagerRatingFormatted = 'true';
    container.classList.add('voyager-yotpo-rating--ready');
    container.classList.remove('voyager-yotpo-rating--empty');
    container.removeAttribute('hidden');
    container.removeAttribute('aria-hidden');
  }

  function formatBottomLine(container, bottomline) {
    if (!bottomline || bottomline.dataset.voyagerRatingFormatted === 'true') return;

    var score = readDataScore(container);
    var count = readDataCount(container);

    bottomline.querySelectorAll('.text-m, .yotpo-bottom-line-text, .yotpo-sr-bottom-line-text').forEach(function(node) {
      if (node.classList.contains('voyager-yotpo-rating-text')) return;
      if (!count) count = parseReviewCount(node.textContent);
    });

    if (shouldHideEmptyRating(score, count)) {
      hideEmptyRating(container);
      return;
    }

    if (!count || !score) return;

    var textEl = getOrCreateRatingText(bottomline);
    textEl.textContent = score + ' (' + count + ')';

    hideNativeYotpoText(bottomline);
    bottomline.dataset.voyagerRatingFormatted = 'true';
    container.classList.add('voyager-yotpo-rating--ready');
    container.classList.remove('voyager-yotpo-rating--empty');
    container.removeAttribute('hidden');
    container.removeAttribute('aria-hidden');
  }

  function hydrateQuickshopRatingFromCard(container) {
    if (!container || !container.classList.contains('quickshop-modal__rating--yotpo')) return false;
    if (container.getAttribute('data-voyager-rating-hydrated') === 'true') {
      if (!container.classList.contains('voyager-yotpo-rating--ready')) {
        finalizeQuickshopRating(container);
      }
      return true;
    }

    var widget = container.querySelector('.yotpo-widget-instance');
    if (!widget) return false;

    if (widget.querySelector('.yotpo-sr-bottom-line-summary, .yotpo-bottomline, .yotpo-bottomLine, .yotpo-sr-stars, .yotpo-stars')) {
      container.setAttribute('data-voyager-rating-hydrated', 'true');
      finalizeQuickshopRating(container);
      return true;
    }

    var productId = widget.getAttribute('data-yotpo-product-id');
    if (!productId) return false;

    var cardWidget = document.querySelector(
      '.product-thumbnail__rating--yotpo .yotpo-widget-instance[data-yotpo-product-id="' + productId + '"]'
    );
    if (
      !cardWidget ||
      !cardWidget.querySelector('.yotpo-sr-bottom-line-summary, .yotpo-bottomline, .yotpo-bottomLine, .yotpo-sr-stars, .yotpo-stars')
    ) {
      return false;
    }

    widget.innerHTML = cardWidget.innerHTML;
    widget.setAttribute('data-yotpo-element-loaded', 'true');
    container.classList.remove('voyager-yotpo-rating--empty');
    container.removeAttribute('hidden');
    container.removeAttribute('aria-hidden');
    container.setAttribute('data-voyager-rating-hydrated', 'true');
    finalizeQuickshopRating(container);
    return true;
  }

  function finalizeQuickshopRating(container) {
    if (!container) return;

    var summary = container.querySelector('.yotpo-sr-bottom-line-summary, .yotpo-bottomline, .yotpo-bottomLine');
    if (!summary) return;

    // Copied card markup can already be marked formatted; still need --ready so
    // native Yotpo score panels stay hidden and we don't show duplicate averages.
    var score = readScoreFromDom(summary) || readDataScore(container);
    var count = readCountFromDom(summary) || readDataCount(container);

    if (shouldHideEmptyRating(score, count)) {
      hideEmptyRating(container);
      return;
    }

    if (score && count) {
      var textEl = getOrCreateRatingText(summary);
      textEl.textContent = score + ' (' + count + ')';
      hideNativeYotpoText(summary);
      summary.dataset.voyagerRatingFormatted = 'true';
      container.classList.add('voyager-yotpo-rating--ready');
      container.classList.remove('voyager-yotpo-rating--empty');
      container.removeAttribute('hidden');
      container.removeAttribute('aria-hidden');
    }
  }

  function formatYotpoCardRatings(root) {
    if (formatting) return;
    formatting = true;

    try {
      var scope = root && root.querySelectorAll ? root : document;
      var selector = '.product-thumbnail__rating--yotpo, .quickshop-modal__rating--yotpo';

      scope.querySelectorAll(selector).forEach(function(container) {
        if (container.classList.contains('voyager-yotpo-rating--empty')) return;
        if (
          container.classList.contains('voyager-yotpo-rating--ready') &&
          container.querySelector('[data-voyager-rating-formatted="true"], .voyager-yotpo-rating-text')
        ) {
          return;
        }

        var dataScore = readDataScore(container);
        var dataCount = readDataCount(container);
        if (shouldHideEmptyRating(dataScore, dataCount)) {
          hideEmptyRating(container);
          return;
        }

        if (container.classList.contains('quickshop-modal__rating--yotpo')) {
          hydrateQuickshopRatingFromCard(container);
        }

        var summary = container.querySelector('.yotpo-sr-bottom-line-summary');
        if (summary) {
          formatStarRatingSummary(container, summary);
          return;
        }

        var bottomline = container.querySelector('.yotpo-bottomline, .yotpo-bottomLine');
        if (bottomline) {
          formatBottomLine(container, bottomline);
        }
      });
    } finally {
      formatting = false;
    }
  }

  function initYotpoWidgets() {
    try {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      } else if (window.yotpo) {
        if (typeof window.yotpo.initWidgets === 'function') window.yotpo.initWidgets();
        if (typeof window.yotpo.refreshWidgets === 'function') window.yotpo.refreshWidgets();
      } else if (window.Yotpo && window.Yotpo.API && typeof window.Yotpo.API.loadWidgets === 'function') {
        window.Yotpo.API.loadWidgets();
      }
    } catch (e) {}
  }

  function clearRefreshTimers() {
    refreshTimers.forEach(function(id) {
      window.clearTimeout(id);
    });
    refreshTimers = [];
  }

  function refreshProductCardRatings(root, options) {
    options = options || {};
    var skipInit = !!options.skipInit;
    var once = !!options.once;

    function run(markEmptyCheck, allowInit) {
      var scope = root && root.querySelectorAll ? root : document;

      // Quickshop: copy rating from card only — never re-init page widgets
      var quickshops = scope.querySelectorAll('.quickshop-modal__rating--yotpo');
      if (quickshops.length) {
        quickshops.forEach(function(container) {
          hydrateQuickshopRatingFromCard(container);
        });
        formatYotpoCardRatings(scope);
        return;
      }

      if (allowInit && !skipInit) {
        initYotpoWidgets();
      }

      if (markEmptyCheck) {
        scope.querySelectorAll('.product-thumbnail__rating--yotpo').forEach(function(container) {
          container.setAttribute('data-voyager-empty-checked', 'true');
        });
      }

      formatYotpoCardRatings(scope);
    }

    clearRefreshTimers();
    run(false, true);

    if (once) return;

    refreshTimers.push(window.setTimeout(function() { run(false, false); }, 400));
    refreshTimers.push(window.setTimeout(function() { run(false, false); }, 1200));
    refreshTimers.push(window.setTimeout(function() { run(true, false); }, 2500));
  }

  function init() {
    refreshProductCardRatings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    refreshProductCardRatings(event.target);
  });

  if (typeof MutationObserver !== 'undefined') {
    var formatTimer;
    var observer = new MutationObserver(function(mutations) {
      // Ignore our own formatting / quickshop hydrates to avoid loops
      var relevant = mutations.some(function(mutation) {
        var node = mutation.target;
        if (!node || !node.closest) return false;
        if (node.closest('.quickshop-modal__rating--yotpo[data-voyager-rating-hydrated="true"]')) return false;
        if (node.closest('.voyager-yotpo-rating--ready')) return false;
        return !!(
          node.classList &&
          (node.classList.contains('yotpo-widget-instance') ||
            node.classList.contains('yotpo-sr-bottom-line-summary') ||
            node.querySelector?.('.yotpo-widget-instance, .yotpo-sr-bottom-line-summary'))
        );
      });
      if (!relevant) return;

      window.clearTimeout(formatTimer);
      formatTimer = window.setTimeout(function() {
        formatYotpoCardRatings();
      }, 200);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.VoyagerProductCardRatings = {
    refresh: refreshProductCardRatings,
    format: formatYotpoCardRatings,
    hydrateQuickshop: function(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.quickshop-modal__rating--yotpo').forEach(hydrateQuickshopRatingFromCard);
      formatYotpoCardRatings(scope);
    }
  };
})();
